var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 80,
    viewBox: "0 0 201 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 47.7737H51.6915L50.7897 49.0362H36V47.7737Z",
    fill: "#D40511"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.41 49.0362H146.201L147.193 47.7737H165.5V49.0362H165.41Z",
    fill: "#D40511"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45.429H53.4951L52.5031 46.6915H36V45.429Z",
    fill: "#D40511"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43.0843H55.2987L54.3068 44.3468H36V43.0843Z",
    fill: "#D40511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.41 46.6915H148.005L148.997 45.429H165.5V46.6915H165.41Z",
    fill: "#D40511"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.71 43.0843H165.409V44.3468H149.718L150.71 43.0843Z",
    fill: "#D40511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9541 49.0362L61.2508 37.944C61.2508 37.944 70.4492 37.944 71.5314 37.944C72.7038 37.944 72.7038 38.3949 72.0725 39.1163C71.5314 39.8378 70.5394 41.1905 69.9983 41.9119C69.7278 42.3628 69.1867 42.9941 70.9001 42.9941C72.7939 42.9941 84.6978 42.9941 84.6978 42.9941C83.6157 44.6174 79.8281 49.1264 73.1547 49.1264C67.7438 49.0362 52.9541 49.0362 52.9541 49.0362Z",
    fill: "#D40511"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.48 43.0843L95.9709 49.1264H84.1572L88.6663 43.0843H100.48Z",
    fill: "#D40511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.704 43.0843L113.195 49.1264H101.291L105.8 43.0843H117.704Z",
    fill: "#D40511"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.582 43.0843C121.582 43.0843 120.68 44.2566 120.319 44.7977C118.786 46.7817 120.139 49.1264 125.009 49.1264C130.6 49.1264 144.127 49.1264 144.127 49.1264L148.636 43.0843H121.582Z",
    fill: "#D40511"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8163 31.0902L54.668 36.5912C54.668 36.5912 76.0409 36.5912 77.2132 36.5912C78.3856 36.5912 78.3856 37.0421 77.7543 37.7636C77.2132 38.485 76.2212 39.8377 75.6802 40.5592C75.4096 40.9199 74.8685 41.6414 76.582 41.6414C78.4758 41.6414 85.7804 41.6414 85.7804 41.6414C85.7804 41.6414 87.3135 39.6574 88.4859 37.9439C90.1993 35.6894 88.6662 31 82.6241 31C77.2132 31.0902 58.8163 31.0902 58.8163 31.0902Z",
    fill: "#D40511"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.696 41.6413H89.6582L97.5941 31.0901H109.498L104.989 37.1323H110.31L114.819 31.0901H126.723L118.696 41.6413Z",
    fill: "#D40511"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.136 31.0901L135.2 41.6413H122.574L130.51 31.0901H143.136Z",
    fill: "#D40511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/dhl.c91de65d16d190bba3420e670c27f667.svg";
export { ForwardRef as ReactComponent };